module.exports = __webpack_public_path__ + "img/nuevos.10a917b4.png";